export {};

/**
 * Loads the portal-tools bundle: a cloud-hosted script that renders portal-only
 * features (currently the Figgy AI chat bubble) inside the portal-proxied device
 * UI. This is a dumb, contract-free loader — it only injects the script and never
 * needs to change again; all feature logic lives in the cloud bundle
 * (app-portal-tools.js), which self-mounts and self-gates. Mirrors
 * ./web-notifications. Reuse this same wire for future portal↔cloud FE features.
 */

const devMode = false;

const cacheBust = `?t=${Date.now()}`;
const scriptUrl = `/portal-assets/app-portal-tools.js${cacheBust}`;

const shouldLoadScript =
  window.location.href.includes('app.infigy.cz') || devMode;

if (shouldLoadScript) {
  const script = document.createElement('script');
  script.src = scriptUrl;
  script.async = true;
  document.head.appendChild(script);
}
